const Money = {
  formatarValor: (valor) => {
    if (valor === null || valor === undefined || valor === "") return "R$ 0,00";

    if (typeof valor === "number") {
      if (!isFinite(valor)) return "R$ 0,00";
      return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(valor);
    }

    const cleaned = String(valor)
      .trim()
      .replace(/\u00A0/g, "")
      .replace(/R\$?/i, "")
      .replace(/\s/g, "")
      .replace(/\./g, "")
      .replace(/,/g, ".");

    const num = Number(cleaned);
    if (Number.isNaN(num) || !isFinite(num)) return "R$ 0,00";

    return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(num);
  }
}


export default Money;
